import React, { Component, PropTypes } from 'react';
import { lang } from '../strings';
import Spinner from 'spin.js';

export default class Progress extends Component {

   render() {
      return (
         <div className="mp-popup-container">
            <div className="mp-popup-content">
               <h2 className="h5 color-dark-blue">{lang.progress.title}</h2>
               <p>{lang.progress.description}</p>
               <div className="mp-progress-container"></div>
            </div>
         </div>
      );
   }

   componentDidMount() {
      if(!this.spinner) {
         this.spinner = new Spinner({
            lines: 10,
            length: 5,
            width: 2,
            radius: 5,
            corners: 1,
            direction: 1,
            color: '#999'
         });
         this.spinner.spin(document.getElementsByClassName('mp-progress-container')[0]);
      }
   }

   componentWillUnmount() {
      if(this.spinner) {
         this.spinner.stop();
         this.spinner = null;
      }
   }
}